import React from 'react';
import styled from 'styled-components';
import cssIngka from '@ingka/variables/colours-css';

interface HighlightTextProps {
  text: string;
  highlight: string;
  className?: string;
}
const StyledSpanHighlight = styled.span`
  color: ${cssIngka.colourNeutral6};
  &[data-highlight='true'] {
    font-weight: bold;
  }
`;
const StyledHighlightText = styled.div`
  display: flex;
  justify-content: top;
`;
// className was added due to not being able to style a specific SpanHighlight
// https://styled-components.com/docs/advanced#styling-normal-react-components
const HighlightText: React.FC<HighlightTextProps> = ({
  text,
  highlight,
  className,
}): JSX.Element => {
  const regExp = new RegExp(`(${highlight})`, 'ig');
  const highlighted = text.split(regExp).map((split, index) => (
    <StyledSpanHighlight key={index} data-highlight={regExp.test(split)}>
      {split}
    </StyledSpanHighlight>
  ));
  return (
    <StyledHighlightText className={className}>
      {highlighted}
    </StyledHighlightText>
  );
};
export default HighlightText;
